<template>
  <section>
    <div class="grid-container">
      <div class="grid-item">
        <welcome :userData="userData" />
        <filtro :isLoading="isLoading" class="mt-3" @buscar="buscar($event)" />
        <statisticsPatients
          class="mt-3"
          :userData="userData"
          :dataDashboard="dataDashboard" />
        <averages
          class="mt-3"
          :averages="averages"
          :dates="fechas"
          :count30="count30"
          :count30ByDoctor="count30ByDoctor"
          :membershipSummary="membershipSummary"
          :byType="byType"
        />
      </div>
      <div class="grid-item">
        <statistics :stadistics="stadistics" />
        <bonus :date="this.fechas" :dashboardBonus="dataDashboard.bonus"/>
        <totalPatiens
          class="mt-3"
          :userData="userData"
          :dataDashboard="dataDashboard"
          :fechas="fechas" />
        <visitTypes class="mt-3" :yearData="dataDashboard.year_data" :userData="userData" />
        <membership class="mt-3" :userData="userData" :memberships="sumMembership" />
      </div>
    </div>
  </section>
</template>

<script>
import Welcome from '../components/welcome.vue'
import filtro from '../components/filter'
import statisticsPatients from '../components/statisticsPatients'
import totalPatiens from '../components/totalPatiens'
import statistics from '../components/statistics'
import averages from '../components/averages'
import membership from '../components/membership'
import bonus from '../components/bonus'
import visitTypes from '../components/visitTypes.vue'
import { readDailyAverageValue } from '@/core/utils/dailyAverageFields'

export default {
  components: {
    averages,
    Welcome,
    filtro,
    statisticsPatients,
    totalPatiens,
    statistics,
    bonus,
    membership,
    visitTypes,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
      required: false,
    },
    dataDashboard: {
      type: Object,
      default: () => {},
      required: false,
    },
    isLoading: {
      type: Boolean,
      default: () => false,
      required: false,
    },
  },
  data() {
    return {
      averages: [],
      stadistics: [],
      fechas: {
        start: '',
        end: '',
      },
      sumMembership: { NP: 0, NC: 0 },
    }
  },
  computed: {
    count30() {
      const avg = this.dataDashboard?.average
      if (!avg || (avg.np_30_count == null && avg.nc_30_count == null)) return null
      return {
        np: parseInt(avg.np_30_count, 10) || 0,
        nc: parseInt(avg.nc_30_count, 10) || 0,
      }
    },
    byType() {
      return Array.isArray(this.dataDashboard?.average?.by_type)
        ? this.dataDashboard.average.by_type
        : []
    },
    membershipSummary() {
      return this.dataDashboard?.average?.summary?.membership || null
    },
    count30ByDoctor() {
      return Array.isArray(this.dataDashboard?.average?.np_nc_30_by_doctor_facility)
        ? this.dataDashboard.average.np_nc_30_by_doctor_facility
        : []
    },
  },
  watch: {
    dataDashboard() {
      this.stadistics = [
        {
          description:
            'Average diario del periodo de la fecha selecionada divido en los dias de ese periodo',
          value: parseInt(this.dataDashboard.average.income_days),
          title: 'Daily Average Income',
        },
        {
          description: 'Suma total del periodo de la fecha selecionada',
          value: parseInt(this.dataDashboard.totals.income),
          title: 'Total Income',
        },
      ]
      this.averages = [
        {
          label: 'AVG_NC',
          title: `Average NC $${this.dataDashboard.average.nc}`,
          averages: this.dataDashboard.average.nc_daily,
        },
        {
          label: 'AVG_NP',
          title: `Average NP $${this.dataDashboard.average.np}`,
          averages: this.dataDashboard.average.np_daily,
        },
        // Nuevos campos agregados
        ...(this.dataDashboard.average.cv_daily?.length ? [{
          label: 'AVG_CV',
          title: `Average CV $${this.typeAverage('CV', this.dataDashboard.average.cv, this.dataDashboard.average.cv_daily, 'AVG_CV')}`,
          averages: this.dataDashboard.average.cv_daily
        }] : []),
        ...(this.dataDashboard.average.fu_daily?.length ? [{
          label: 'AVG_FU',
          title: `Average FU $${this.typeAverage('F/U', this.dataDashboard.average.fu, this.dataDashboard.average.fu_daily, 'AVG_FU')}`,
          averages: this.dataDashboard.average.fu_daily
        }] : []),
        ...(this.dataDashboard.average.pi_daily?.length ? [{
          label: 'AVG_PI',
          title: `Average PI $${this.typeAverage('P/I', this.dataDashboard.average.pi, this.dataDashboard.average.pi_daily, 'AVG_PI')}`,
          averages: this.dataDashboard.average.pi_daily
        }] : []),
        ...(this.dataDashboard.average.pp_daily?.length ? [{
          label: 'AVG_PP',
          title: `Average PP $${this.typeAverage('P/P', this.dataDashboard.average.pp, this.dataDashboard.average.pp_daily, 'AVG_PP')}`,
          averages: this.dataDashboard.average.pp_daily
        }] : []),
        ...(this.dataDashboard.average.rs_daily?.length ? [{
          label: 'AVG_RS',
          title: `Average RS $${this.typeAverage('R/S', this.dataDashboard.average.rs, this.dataDashboard.average.rs_daily, 'AVG_RS')}`,
          averages: this.dataDashboard.average.rs_daily
        }] : [])
      ]
      this.sumMembership = this.dataDashboard.memberships
    },
  },
  methods: {
    typeAverage(prefix, backendValue, dailyData, fieldName) {
      const row = (this.dataDashboard?.average?.by_type || []).find(
        item => item.prefix === prefix
      )
      if (row && row.average != null && row.average !== '') {
        return Math.trunc(Number(row.average) || 0)
      }
      if (backendValue != null && backendValue !== '') {
        return Math.trunc(Number(backendValue) || 0)
      }
      if (!dailyData || !dailyData.length) return 0
      const sum = dailyData.reduce(
        (acc, item) => acc + readDailyAverageValue(item, fieldName),
        0
      )
      return Math.round(sum / dailyData.length)
    },
    buscar(filtro) {
      this.fechas = {
        start: filtro.start,
        end: filtro.end,
      }
      this.$emit('buscar', filtro)
    },
  },
}
</script>

<style scoped lang="scss">
@import '../assets/cssDashboards.css';
</style>
